import { GITHUB_API_BASE, GITHUB_REPO, resolveBranch } from '../github.const'
import type { GitHubFile } from '../github.interface'

import { buildGithubHeaders } from './buildGithubHeaders'

export async function fetchRepositoryTree(
  branch: string | null = null,
  path: string = '',
  repo: string = GITHUB_REPO
): Promise<GitHubFile[]> {
  const resolvedBranch = resolveBranch(branch, repo)
  const url = `${GITHUB_API_BASE}/${repo}/contents/${path}?ref=${resolvedBranch}`

  try {
    const response = await fetch(url, {
      headers: buildGithubHeaders('application/vnd.github.v3+json'),
      cache: 'force-cache',
    })

    if (!response.ok) {
      console.error(`Failed to fetch repository tree: ${response.status} ${response.statusText}`)
      return []
    }

    const data = (await response.json()) as GitHubFile | GitHubFile[]
    return Array.isArray(data) ? data : [data]
  } catch (error) {
    console.error('Error fetching repository tree:', error)
    return []
  }
}
